import { z } from "zod";

// ── Response schemas (read sides of /api/config/*) ───────────────────────

export const payPlanSchema = z.object({
  id: z.string(),
  payPlanCode: z.string(),
  payPlan: z.string(),
  policyNumberPrefix: z.string().nullable(),
});
export const payPlanArraySchema = z.array(payPlanSchema);
export type PayPlan = z.infer<typeof payPlanSchema>;

export const cancelReasonSchema = z.object({
  id: z.string(),
  cancelReasonCode: z.string(),
  cancelReason: z.string(),
});
export const cancelReasonArraySchema = z.array(cancelReasonSchema);
export type CancelReason = z.infer<typeof cancelReasonSchema>;

export const regionSchema = z.object({
  id: z.string(),
  regionName: z.string(),
  agencyTeam: z.string(),
});
export const regionArraySchema = z.array(regionSchema);
export type Region = z.infer<typeof regionSchema>;

export const paramWorkflowSchema = z.object({
  id: z.string(),
  claimTeamHistoryWorkflowTo: z.string(),
  vinylUrl: z.string(),
});
export type ParamWorkflow = z.infer<typeof paramWorkflowSchema>;

export const paramUploadPdfSchema = z.object({
  id: z.string(),
  claimTeamHistoryHelpFile: z.string(),
  claimTeamHistoryHelpFileName: z.string(),
});
export type ParamUploadPdf = z.infer<typeof paramUploadPdfSchema>;

export const configUserSchema = z.object({
  id: z.string(),
  samAccountName: z.string(),
  name: z.string(),
  email: z.string().nullable(),
  title: z.string().nullable(),
  department: z.string().nullable(),
  firstLastName: z.string().nullable(),
  lastFirstName: z.string().nullable(),
});
export const configUserArraySchema = z.array(configUserSchema);
export type ConfigUser = z.infer<typeof configUserSchema>;

// ── Mutation schemas ─────────────────────────────────────────────────────

export const createCancelReasonSchema = z.object({
  cancelReasonCode: z.string().min(1),
  cancelReason: z.string().min(1),
});

export const updateCancelReasonSchema = z.object({
  cancelReasonCode: z.string().min(1).optional(),
  cancelReason: z.string().min(1).optional(),
});

export const createPayPlanSchema = z.object({
  payPlanCode: z.string().min(1),
  payPlan: z.string().min(1),
  policyNumberPrefix: z.string().optional(),
});

export const updatePayPlanSchema = z.object({
  payPlanCode: z.string().min(1).optional(),
  payPlan: z.string().min(1).optional(),
  policyNumberPrefix: z.string().optional(),
});

export const createRegionSchema = z.object({
  regionName: z.string().min(1),
  agencyTeam: z.string().min(1),
});

export const updateRegionSchema = z.object({
  regionName: z.string().min(1).optional(),
  agencyTeam: z.string().min(1).optional(),
});

export const updateParamSchema = z.object({
  isAgency: z.boolean().optional(),
  isPolicy: z.boolean().optional(),
  isClaim: z.boolean().optional(),
  claimTeamHistoryWorkflowTo: z.string().optional(),
  vinylUrl: z.string().optional(),
  period: z.string().optional(),
  claimTeamHistoryHelpFile: z.string().optional(),
  claimTeamHistoryHelpFileName: z.string().optional(),
});
